import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import SelectForm from 'app/commons/components/SelectForm';
import SearchForm from 'app/commons/components/SearchForm';
import { withGlobalData } from 'app/utils/withGlobalData';
import Paginate from 'app/commons/components/Paginate';
import { ResultAPI } from 'app/requests/apiRequest';
import { buildParams } from 'app/utils/pagination';
import Title from 'app/components/layouts/Title';
import List from 'app/components/listening/List';
import * as listenApi from 'app/requests/listens';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { useState } from 'react';
import env from '.env.json';

export default function Index({ listening }) {
  const router = useRouter();
  const { t } = useTranslation();
  const { auth } = useSelector((state: AppStoreState) => state.global);

  const [params, setParams] = useState({
    keyword: router.query.keyword || '',
    page: router.query.page || 1,
    learned: router.query.learned || '',
  });

  const setDataParams = (value: number | string, name: string, page: number | null = null) => {
    let newParams = { ...params, [name]: value };
    if (page) newParams.page = page;
    setParams(newParams);
    const url = `/listening${buildParams(newParams)}`
    router.push(url)
  }

  return (
    <section className="box-card-area list-test">
      <NextSeo
        title={t('listening.title')}
        description={t('listening.listen_description', { app_name: env.APP_NAME })}
      />
      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title='listening.title' />
              <div className="mt-3 row">
                <div className='mx-auto position-relative col-md-6'>
                  <SearchForm setDataParams={setDataParams} />
                </div>
                {auth?.id &&
                  <div className='form-group select-learned col-md-6'>
                    <SelectForm
                      value={params.learned}
                      handleChange={(value: string) => setDataParams(value, 'learned', 1)}
                      options={
                        <>
                          <option value="">{t('listening.option_all')}</option>
                          <option value="1">{t('listening.learned')}</option>
                          <option value="2">{t('listening.unlearned')}</option>
                        </>
                      }
                      showOptionBlank={false}
                    />
                  </div>
                }
              </div>
              {listening?.data?.length > 0 &&
                <div className='mt-3'>
                  <List
                    listens={listening?.data}
                    code={router.locale}
                  />
                  <Paginate
                    data={listening}
                    handleChangePage={(page: number) => setDataParams(page, 'page')}
                  />
                </div>
              }
              {!listening?.data?.length &&
                <div className='text-danger text-center mt-3 text-size-xl'>
                  {t('commons.result_notfound')}
                </div>
              }
            </div>
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query, req }) => {
  try {
    const token = req.cookies['auth_token'];
    const listening = await listenApi.getListens({
      ...query,
      code: locale,
      direction: 'asc',
      from: 'home_page'
    }, token) as ResultAPI;

    return ({
      props: {
        ...await serverSideTranslations(locale, ['common']),
        listening
      },
    })
  } catch (error) {
    return { notFound: true };
  }
});
